module.exports = __webpack_public_path__ + "img/Element11_Fehler_Ziffernrechnen.e5b00203.png";